// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_PARTS_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/is-editable.js